import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AreaSelect from "@/components/AreaSelect.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

var buildConfig = require("@/build/" + process.env.BUILD_ENV + ".js");

import { Encrypt } from "@/utils/encryption.js";
export default {
  name: "MemberProfile",
  components: {
    AreaSelect: AreaSelect
  },
  data: function data() {
    var _this = this;

    var validateRePass = function validateRePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (_this.$pub.guarantee(1, value)) {
        if (_this.$pub.guarantee(1, value) == true) {
          callback();
        } else {
          callback(new Error(_this.$pub.guarantee(1, value)));
        }
      } else {
        callback();
      }
    };

    var validatePhone = function validatePhone(rule, value, callback) {
      var reg = /^1\d{10}$/;

      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (value.length < 11) {
        callback(new Error("手机号码不足11位，请重新输入！"));
      } else if (reg.test(value) === false) {
        callback(new Error("请输入正确的11位号码！"));
      } else {
        callback();
      }
    };

    return {
      test: [66, 67],
      current: "1",
      types: [{
        type: "1",
        label: "个人信息"
      }, {
        type: "2",
        label: "账户安全"
      }],
      attrs: [],
      userInfo: {
        avatar: "",
        nickname: "",
        mobile: "",
        sex: "",
        birthday: "",
        province_id: "",
        city_id: "",
        district_id: "",
        face_photo: ""
      },
      rules: {
        avatar: [{
          required: true,
          message: "头像不能为空",
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "昵称不能为空",
          trigger: "blur"
        }],
        sex: [{
          required: false,
          message: "性别不能为空",
          trigger: "change"
        }],
        birthday: [{
          required: false,
          message: "出生日期不能为空",
          trigger: "change"
        }],
        district_id: [{
          required: false,
          message: "所在城市不能为空",
          trigger: "change"
        }]
      },
      showPasswordDialog: false,
      passwordForm: {
        mobile: "",
        password: "",
        sms_code: ""
      },
      passwordRules: {
        mobile: [{
          required: true,
          message: "手机号不能为空",
          trigger: "blur"
        }],
        password: [{
          required: true,
          validator: validateRePass,
          trigger: "blur"
        }],
        sms_code: [{
          required: true,
          message: "请输入短信验证码",
          trigger: "blur"
        }]
      },
      countDown: 0,
      uploadUrl: buildConfig.BASE_URL + "/api/app/public/img",
      headers: {
        Authorization: "Bearer " + localStorage.studentToken
      },
      options: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      currentUploadIndex: 0,
      showPhoneDialog: false,
      phoneForm: {
        old_sms_code: "",
        //老手机的验证码
        mobile: "",
        //新手机号
        sms_code: "" //新手机号的验证码

      },
      phoneCountDown: 0,
      newPhoneCountDown: 0,
      phoneRules: {
        mobile: [{
          required: true,
          validator: validatePhone,
          trigger: "blur"
        }],
        old_sms_code: [{
          required: true,
          message: "请输入短信验证码",
          trigger: "blur"
        }],
        sms_code: [{
          required: true,
          message: "请输入短信验证码",
          trigger: "blur"
        }]
      },
      changePhoneStep: 1,
      columns: ['MPAcc', 'MLIS', 'MAud', 'MEM', 'MBA', 'MPA', 'MTA', 'EMBA']
    };
  },
  computed: {
    hideMobile: function hideMobile() {
      return this.userInfo.mobile.substring(0, 3) + "****" + this.userInfo.mobile.substring(7);
    },
    schoolCount: function schoolCount() {
      return this.$store.getters.schoolCount;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.initData();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    initData: function () {
      var _initData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var data, attrs, attrsCopy, _loop, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, obj;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.get("/api/app/userInfo");

              case 2:
                data = _context2.sent;
                this.userInfo = data;
                this.userInfo.origin_school_name = data.origin_school_name;
                this.userInfo.avatar = data.avatar;
                this.userInfo.nickname = data.nickname;
                this.userInfo.mobile = data.mobile;
                this.userInfo.face_photo = data.face_photo;

                if (data.sex != 0 && data.sex != 1) {
                  data.sex = 3;
                }

                this.userInfo.sex = data.sex.toString();
                this.userInfo.birthday = data.birthday == 0 || data.birthday == "NaN-aN-aN" ? "" : data.birthday;
                this.userInfo.province_id = data.province_id || "";
                this.userInfo.city_id = data.city_id || "";
                this.userInfo.district_id = data.district_id || ""; // 筛选出用户未填写过的信息项，进行初始化赋值

                _context2.next = 17;
                return this.$http.get("/api/app/attribute/1");

              case 17:
                attrs = _context2.sent;
                attrsCopy = JSON.parse(JSON.stringify(attrs));

                _loop = function _loop(i) {
                  if (data.attr.find(function (t) {
                    return t.attr_id == attrsCopy[i].id;
                  })) {
                    attrsCopy.splice(i, 1);
                  }
                };

                for (i = attrsCopy.length - 1; i >= 0; i--) {
                  _loop(i);
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 24;

                for (_iterator = attrsCopy[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  value = _step.value;
                  obj = {
                    address: "",
                    attr_id: value.id,
                    attr_val: "",
                    city_id: "",
                    city_name: "",
                    district_id: "",
                    district_name: "",
                    end_time: 0,
                    province_id: "",
                    province_name: "",
                    start_time: 0,
                    type: value.type
                  };
                  data.attr.push(obj);
                } // 已填写过的信息项进行赋值


                _context2.next = 32;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2["catch"](24);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 32:
                _context2.prev = 32;
                _context2.prev = 33;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 35:
                _context2.prev = 35;

                if (!_didIteratorError) {
                  _context2.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context2.finish(35);

              case 39:
                return _context2.finish(32);

              case 40:
                this.setDeaultValue(data, attrs);
                this.attrs = attrs;
                this.passwordForm.mobile = data.mobile;
                this.$nextTick(function () {
                  _this2.$refs["userForm"].clearValidate();
                });
                triggerLoaded(this);

              case 45:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[24, 28, 32, 40], [33,, 35, 39]]);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }(),
    setDeaultValue: function setDeaultValue(data, attrs) {
      for (var i = 0; i < attrs.length; i++) {
        var trigger = "blur";

        for (var j = 0; j < data.attr.length; j++) {
          // 已填写的属性赋值
          if (attrs[i].id == data.attr[j].attr_id) {
            switch (attrs[i].type) {
              case 1:
                this.handleProfile(data.attr[j], i, 1); // if (data.attr[j].attr_val) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i,
                //     parseInt(data.attr[j].attr_val),
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }

                trigger = "change";
                break;

              case 2:
                this.handleProfile(data.attr[j], i, 2); // if (data.attr[j].attr_val) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i,
                //     data.attr[j].attr_val.split(",").map(function (item) {
                //       return +item;
                //     }),
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i, []);
                // }

                trigger = "change";
                break;

              case 3:
                this.handleProfile(data.attr[j], i, 3); // if (data.attr[j].attr_val) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i,
                //     data.attr[j].attr_val + "",
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }

                break;

              case 4:
                this.handleProfile(data.attr[j], i, 3); // if (data.attr[j].attr_val) {
                //   this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val);
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }

                trigger = "change";
                break;

              case 5:
                this.handleProfile(data.attr[j], i, 4, "province_id");
                this.handleProfile(data.attr[j], i, 4, "city_id"); // this.handleProfile(data.attr[j], i, 4, "district_id");
                // if (data.attr[j].province_id) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "province_id",
                //     data.attr[j].province_id,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "province_id", "");
                // }
                // if (data.attr[j].city_id) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "city_id",
                //     data.attr[j].city_id,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "city_id", "");
                // }
                // if (data.attr[j].city_id) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "city_id",
                //     data.attr[j].city_id,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "city_id", "");
                // }

                if (data.attr[j].district_id) {
                  this.$set(this.userInfo, "attr" + i, data.attr[j].district_id);
                } else {
                  this.$set(this.userInfo, "attr" + i + "city_id", "");
                } // if (data.attr[j].address) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "address",
                //     data.attr[j].address,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "address", "");
                // }


                this.handleProfile(data.attr[j], i, 4, "address");
                trigger = "change";
                break;

              case 6:
                if (data.attr[j].attr_val) {
                  this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val);
                } else {
                  this.$set(this.userInfo, "attr" + i, "");
                }

                break;

              case 7:
                if (data.attr[j].attr_val) {
                  this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val * 1000);
                } else {
                  this.$set(this.userInfo, "attr" + i, "");
                }

                trigger = "change";
                break;

              case 8:
                if (data.attr[j].start_time) {
                  this.$set(this.userInfo, "attr" + i, [data.attr[j].start_time * 1000, data.attr[j].end_time * 1000]);
                } else {
                  this.$set(this.userInfo, "attr" + i, "");
                }

                trigger = "change";
                break;

              case 9:
                this.handleProfile(data.attr[j], i, 3); // if (data.attr[j].attr_val) {
                //   this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val);
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }

                break;

              default:
                if (data.attr[j].attr_val) {
                  this.$set(this.userInfo, "attr" + i, JSON.parse(data.attr[j].attr_val));
                  var _arr = [];
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = JSON.parse(data.attr[j].attr_val)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var value = _step2.value;

                      _arr.push({
                        url: value
                      });
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }

                  attrs[i].fileList = _arr;
                } else {
                  this.$set(this.userInfo, "attr" + i, []);
                  attrs[i].fileList = [];
                }

            }
          }
        }

        var arr = [{
          required: attrs[i].is_required == 1,
          message: attrs[i].attr + "不能为空",
          trigger: trigger
        }];
        this.$set(this.rules, "attr" + i, arr);
      }
    },
    handleProfile: function handleProfile(data, i, type, name) {
      if (type == 1) {
        this.$set(this.userInfo, "attr" + i, data.attr_val ? parseInt(data.attr_val) : "");
      } else if (type == 2) {
        if (data.attr_val) {
          this.$set(this.userInfo, "attr" + i, data.attr_val.split(",").map(function (item) {
            return +item;
          }));
        } else {
          this.$set(this.userInfo, "attr" + i, []);
        }
      } else if (type == 3) {
        this.$set(this.userInfo, "attr" + i, data.attr_val ? data.attr_val + "" : "");
      } else if (type == 4) {
        this.$set(this.userInfo, "attr" + i + name, data[name] ? data[name] : "");
      }
    },
    changeTab: function changeTab(item) {
      this.current = item.type;
    },
    areaChange: function areaChange(area) {
      this.userInfo.province_id = area.provinceId;
      this.userInfo.city_id = area.cityId;
      this.userInfo.district_id = area.districtId;
    },
    areaChangeMore: function areaChangeMore(area) {
      this.userInfo["attr" + area.index + "province_id"] = area.provinceId;
      this.userInfo["attr" + area.index + "city_id"] = area.cityId;
      this.$set(this.userInfo, "attr" + area.index, area.districtId);
    },
    saveUser: function saveUser() {
      var _this3 = this;

      this.$refs["userForm"].validate(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(valid) {
          var data, attrVals, i, val, obj;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  data = {};
                  data.nickname = _this3.userInfo.nickname;
                  data.avatar = _this3.userInfo.avatar;
                  data.sex = _this3.userInfo.sex;
                  data.face_photo = _this3.userInfo.face_photo;
                  data.birthday = _this3.userInfo.birthday ? new Date(_this3.userInfo.birthday).format("yyyy-MM-dd") : "";
                  data.province_id = _this3.userInfo.province_id;
                  data.city_id = _this3.userInfo.city_id;
                  data.district_id = _this3.userInfo.district_id;
                  data.apply_major = _this3.userInfo.apply_major;
                  data.apply_colleges = _this3.userInfo.apply_colleges;
                  attrVals = [];
                  i = 0;

                case 15:
                  if (!(i < _this3.attrs.length)) {
                    _context3.next = 49;
                    break;
                  }

                  val = _this3.userInfo["attr" + i];
                  obj = {};
                  obj.attr_id = _this3.attrs[i].id;
                  _context3.t0 = _this3.attrs[i].type;
                  _context3.next = _context3.t0 === 1 ? 22 : _context3.t0 === 2 ? 24 : _context3.t0 === 3 ? 26 : _context3.t0 === 4 ? 28 : _context3.t0 === 5 ? 30 : _context3.t0 === 6 ? 35 : _context3.t0 === 7 ? 37 : _context3.t0 === 8 ? 39 : _context3.t0 === 9 ? 42 : 44;
                  break;

                case 22:
                  obj.attr_val_id = val;
                  return _context3.abrupt("break", 45);

                case 24:
                  obj.attr_val_id = val.join(",");
                  return _context3.abrupt("break", 45);

                case 26:
                  obj.attr_val_id = val;
                  return _context3.abrupt("break", 45);

                case 28:
                  obj.attr_val_id = val;
                  return _context3.abrupt("break", 45);

                case 30:
                  obj.province_id = _this3.userInfo["attr" + i + "province_id"];
                  obj.city_id = _this3.userInfo["attr" + i + "city_id"];
                  obj.district_id = _this3.userInfo["attr" + i];
                  obj.address = _this3.userInfo["attr" + i + "address"];
                  return _context3.abrupt("break", 45);

                case 35:
                  obj.attr_val_id = val;
                  return _context3.abrupt("break", 45);

                case 37:
                  obj.attr_val_id = val / 1000 || "";
                  return _context3.abrupt("break", 45);

                case 39:
                  obj.start_time = val[0] / 1000 || "";
                  obj.end_time = val[1] / 1000 || "";
                  return _context3.abrupt("break", 45);

                case 42:
                  obj.attr_val_id = val;
                  return _context3.abrupt("break", 45);

                case 44:
                  obj.attr_val_id = JSON.stringify(val);

                case 45:
                  attrVals.push(obj);

                case 46:
                  i++;
                  _context3.next = 15;
                  break;

                case 49:
                  data.user_attr = JSON.stringify(attrVals);
                  _context3.next = 52;
                  return _this3.$http.put("/api/app/user", data);

                case 52:
                  _context3.next = 54;
                  return _this3.$success("保存成功");

                case 54:
                  _this3.$store.dispatch("get_user_info");

                case 55:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getSmsCode: function () {
      var _getSmsCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        var timer;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.passwordForm.mobile == "")) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return this.$info("请输入手机号");

              case 3:
                return _context4.abrupt("return");

              case 4:
                _context4.next = 6;
                return this.$services.CodeService.sendSmsCode(this.passwordForm.mobile, "getPassword");

              case 6:
                this.countDown = 60;
                timer = setInterval(function () {
                  _this4.countDown--;

                  if (_this4.countDown == 0) {
                    clearInterval(timer);
                  }
                }, 1000);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getSmsCode() {
        return _getSmsCode.apply(this, arguments);
      }

      return getSmsCode;
    }(),
    submitChangePassword: function () {
      var _submitChangePassword = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.$refs["passwordForm"].validate(
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee5(valid) {
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (valid) {
                              _context5.next = 2;
                              break;
                            }

                            return _context5.abrupt("return");

                          case 2:
                            _context5.next = 4;
                            return _this5.$http.post("/api/app/password", {
                              mobile: _this5.userInfo.mobile,
                              password: Encrypt(_this5.passwordForm.password),
                              sms_code: _this5.passwordForm.sms_code
                            });

                          case 4:
                            _this5.showPasswordDialog = false;
                            _this5.passwordForm.sms_code = "";
                            _this5.passwordForm.password = "";
                            _context5.next = 9;
                            return _this5.$success("密码修改成功，请重新登录");

                          case 9:
                            _this5.$store.commit("logout");

                            _this5.$LoginModal.login({
                              type: "passwordLogin",
                              store: _this5.$store
                            });

                          case 11:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function submitChangePassword() {
        return _submitChangePassword.apply(this, arguments);
      }

      return submitChangePassword;
    }(),
    onBeforeUpload: function onBeforeUpload(file) {
      var ext = file.name.split(".").pop();

      if (ext != "jpg" && ext != "jpeg" && ext != "png") {
        this.$error("请上传jpg或者png图片");
        return false;
      }
    },
    uploadSuccess: function () {
      var _uploadSuccess = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(response) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(response.code != 200)) {
                  _context7.next = 5;
                  break;
                }

                _context7.next = 3;
                return this.$error(response.msg);

              case 3:
                _context7.next = 6;
                break;

              case 5:
                this.userInfo.avatar = response.data.url;

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function uploadSuccess(_x3) {
        return _uploadSuccess.apply(this, arguments);
      }

      return uploadSuccess;
    }(),
    uploadFaceSuccess: function () {
      var _uploadFaceSuccess = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(response) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(response.code != 200)) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 3;
                return this.$error(response.msg);

              case 3:
                _context8.next = 6;
                break;

              case 5:
                this.userInfo.face_photo = response.data.url;

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function uploadFaceSuccess(_x4) {
        return _uploadFaceSuccess.apply(this, arguments);
      }

      return uploadFaceSuccess;
    }(),
    currentClickIndex: function currentClickIndex(index) {
      this.currentUploadIndex = index;
    },
    // 单图上传成功
    uploadSuccessSingle: function () {
      var _uploadSuccessSingle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(response) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(response.code != 200)) {
                  _context9.next = 5;
                  break;
                }

                _context9.next = 3;
                return this.$error(response.msg);

              case 3:
                _context9.next = 6;
                break;

              case 5:
                this.userInfo["attr" + this.currentUploadIndex] = response.data.url;

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function uploadSuccessSingle(_x5) {
        return _uploadSuccessSingle.apply(this, arguments);
      }

      return uploadSuccessSingle;
    }(),
    // 多图上传成功
    uploadSuccessMore: function uploadSuccessMore(response, file, fileList) {
      if (response.code != 200) {
        this.$error(response.msg);
      } else {
        var fileBox = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = fileList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var value = _step3.value;
            var path = value.response ? value.response.data.url : value.url;
            fileBox.push(path);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        this.userInfo["attr" + this.currentUploadIndex] = fileBox;
      }
    },
    // 多图上传超出个数限制
    uploadExceed: function uploadExceed() {
      this.$warning("已达最大上传个数！");
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var fileBox = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = fileList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var value = _step4.value;
          var path = value.response.data.url;
          fileBox.push(path);
        } // this.fileLength = fileBox.length;
        // fileBox = fileBox.join(',');

      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.userInfo["attr" + this.currentUploadIndex] = fileBox;
    },
    onFacePhotoBeforeUpload: function onFacePhotoBeforeUpload() {},

    /**
     * 更换手机号
     * step1.验证旧手机
     * step2.绑定新手机
     */
    cancelDialog: function cancelDialog() {
      this.$refs["phoneForm"].clearValidate();
      this.showPhoneDialog = false;
    },
    // 获取旧手机的验证码
    getOldSmsCode: function () {
      var _getOldSmsCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.$http.post("/api/app/user/changeMobile/code").then(function () {
                  _this6.showPhoneDialog = true;
                  _this6.phoneCountDown = 60;
                  var timer = setInterval(function () {
                    _this6.phoneCountDown--;

                    if (_this6.phoneCountDown == 0) {
                      clearInterval(timer);
                    }
                  }, 1000);
                });

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getOldSmsCode() {
        return _getOldSmsCode.apply(this, arguments);
      }

      return getOldSmsCode;
    }(),
    // 获取新手机号的验证码
    getNewSmsCode: function () {
      var _getNewSmsCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.$refs["phoneForm"].validateField("mobile",
                /*#__PURE__*/
                function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee11(validMessage) {
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            if (!(validMessage != "")) {
                              _context11.next = 2;
                              break;
                            }

                            return _context11.abrupt("return");

                          case 2:
                            _context11.next = 4;
                            return _this7.$http.post("/api/app/user/changeMobile/newCode", {
                              mobile: _this7.phoneForm.mobile
                            }).then(function () {
                              _this7.newPhoneCountDown = 60;
                              var timer = setInterval(function () {
                                _this7.newPhoneCountDown--;

                                if (_this7.newPhoneCountDown == 0) {
                                  clearInterval(timer);
                                }
                              }, 1000);
                            });

                          case 4:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11);
                  }));

                  return function (_x6) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getNewSmsCode() {
        return _getNewSmsCode.apply(this, arguments);
      }

      return getNewSmsCode;
    }(),
    // 点击更换手机号按钮
    changeMobile: function () {
      var _changeMobile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                // this.getOldSmsCode();
                if (this.phoneCountDown <= 0) {
                  this.getOldSmsCode();
                } else {
                  this.showPhoneDialog = true;
                }

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function changeMobile() {
        return _changeMobile.apply(this, arguments);
      }

      return changeMobile;
    }(),
    // 第一步提交
    submitChangePhone: function () {
      var _submitChangePhone = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.$refs["phoneForm"].validateField("old_sms_code",
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee14(validMessage) {
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            if (!(validMessage != "")) {
                              _context14.next = 2;
                              break;
                            }

                            return _context14.abrupt("return");

                          case 2:
                            _context14.next = 4;
                            return _this8.$http.post("/api/app/user/changeMobile/verifyOld", {
                              sms_code: _this8.phoneForm.old_sms_code
                            });

                          case 4:
                            _this8.phoneCountDown = 0;
                            _this8.changePhoneStep = 2;

                          case 6:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14);
                  }));

                  return function (_x7) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function submitChangePhone() {
        return _submitChangePhone.apply(this, arguments);
      }

      return submitChangePhone;
    }(),
    // 第二步提交
    submitNewPhone: function () {
      var _submitNewPhone = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.$refs["phoneForm"].validate(
                /*#__PURE__*/
                function () {
                  var _ref5 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee16(valid) {
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            if (valid) {
                              _context16.next = 2;
                              break;
                            }

                            return _context16.abrupt("return");

                          case 2:
                            _context16.next = 4;
                            return _this9.$http.post("/api/app/user/changeMobile/verifyNew", {
                              sms_code: _this9.phoneForm.sms_code,
                              old_sms_code: _this9.phoneForm.old_sms_code,
                              mobile: _this9.phoneForm.mobile
                            });

                          case 4:
                            _this9.$success("更换成功，返回至个人中心");

                            _this9.cancelDialog();

                            _this9.initData();

                          case 7:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16);
                  }));

                  return function (_x8) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function submitNewPhone() {
        return _submitNewPhone.apply(this, arguments);
      }

      return submitNewPhone;
    }()
  }
};